import React, { useEffect } from 'react';
import {
	CANCEL,
	CONFIRM,
	DOWNGROADE_CHANGE_TIER_CANCEL_BUTTON,
	SUBSCRIPTION_TIER_CHANGE_B_MODAL_TITLE,
	SUBSCRIPTION_TIER_CHANGE_B_MODAL_DESCRIPTION,
} from '../../../../constants/Copy';
import Modal from '../../../common/modal/Modal';
import TierList from '../tierdescription/TierList';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_ACCOUNT,
	EVT_ELEMENT_INTERACTION,
	EVT_SUBSCRIPTION_CHANGE,
	EVT_CONFIRM,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_SUBSCRIPTION_CHANGE_CONFIRM,
} from '../../../../constants/SnowplowEvents';
import Button, {
	BUTTON_KIND_TRANSPARENT,
	BUTTON_KIND_BRAND,
} from '../../../common/buttons/button/Button';
import { useModifySearchParams } from '../../../../hooks/useSearchParams';

const ChangeTierModal = ({
	active,
	setActive,
	tierPresentation,
	gigyaUser,
	currentTierId,
	selectedTier,
	changeTier,
	confirmButtonDisabled,
	subscriptionNumber,
}) => {
	const { setSearchParam, removeSearchParam } = useModifySearchParams();

	useEffect(() => {
		if (active) {
			setSearchParam('confirmationModal', 'true');
		} else {
			removeSearchParam('confirmationModal');
		}

		// Cleanup on unmount
		return () => {
			removeSearchParam('confirmationModal');
		};
	}, [active, setSearchParam, removeSearchParam]);

	return (
		<Modal show={active}>
			<div className="modal-change-tier" data-test="change-tier-downgrade">
				{tierPresentation.title && (
					<h2 className="modal-change-tier__title">
						{SUBSCRIPTION_TIER_CHANGE_B_MODAL_TITLE.replace('{tier}', tierPresentation.title)}
					</h2>
				)}
				{tierPresentation && (
					<div className="modal-change-tier__table">
						<TierList tierFeatures={tierPresentation} hasBorder={false} removeAsterisk />
					</div>
				)}
				<p className="modal-change-tier__description">
					{SUBSCRIPTION_TIER_CHANGE_B_MODAL_DESCRIPTION}
				</p>
				<div className="modal-change-tier__buttons">
					<Button
						large
						data-test="change-tier-cancel-button"
						kind={BUTTON_KIND_TRANSPARENT}
						onClick={() => {
							initiateTrackStructEvent({
								category: EVT_ACCOUNT,
								action: EVT_SUBSCRIPTION_CHANGE,
								label: EVT_CONFIRM,

								rtlElementContext: {
									elementInteraction: EVT_ELEMENT_INTERACTION,
									elementGroup: EVT_SUBSCRIPTION_CHANGE,
									elementType: EVT_ELEMENT_TYPE_BUTTON,
									elementName: EVT_SUBSCRIPTION_CHANGE_CONFIRM,
									elementLabel: DOWNGROADE_CHANGE_TIER_CANCEL_BUTTON,
								},
								rtlFunnel: {
									funnelName: EVT_SUBSCRIPTION_CHANGE,
									funnelStepName: 'Cancel Subscription Change',
									funnelStep: '03',
									funnelSubscriptionType: `${currentTierId}|${selectedTier}`,
								},
								rtlUser: { rtlUserId: gigyaUser.UID },
								...(subscriptionNumber && {
									rtlPurchase: {
										videolandSubscriptionNumber: subscriptionNumber,
									},
								}),
							});
							setActive(false);
						}}
					>
						{CANCEL}
					</Button>
					<Button
						large
						data-test="change-tier-downgrade-confirm-button"
						kind={BUTTON_KIND_BRAND}
						onClick={changeTier}
						disabled={confirmButtonDisabled}
					>
						{CONFIRM}
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default ChangeTierModal;
